<!--
 * @Author: 艾斯
 * @Date: 2019-12-19 10:24:05
 * @LastEditTime : 2019-12-27 15:57:01
 * @LastEditors  : Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /vue/wei/src/views/assess/Report.vue
 -->
<template>
  <div class="report">
    <div class="nopadding">
      <img src="../../assets/pdf_head01.jpg" alt />
      <img src="../../assets/pdf_head02.jpg" alt />
      <div class="userinfo">
        <div class="usertit">测评名称：{{ name }}</div>
        <div class="username">
          <span v-show="userInfo.realName">{{ userInfo.realName }}</span>
          <span v-show="!userInfo.realName">{{ userInfo.userName }}</span>
        </div>
        <div class="usertime">{{ finishTime | stringOut }}</div>
        <img src="../../assets/pdf_head03.jpg" alt />
      </div>
    </div>
    <div class="content">
      <div class="cell_title">整体概览</div>
      <van-divider class="m_bottom40" />
      <div class="whole m_bottom40">
        <van-row
          type="flex"
          justify="space-around"
          align="center"
          class="m_bottom"
        >
          <van-col span="9">
            <van-circle
              v-model="currentRate"
              layer-color="#DCDFE6"
              :rate="whole.score"
              :speed="50"
              color="#19A7C4"
              :text="whole.scoreText"
              :stroke-width="120"
              :size="230"
              class="circle"
            >
              <template slot="default">
                <div class="scoretext">
                  {{ whole.scoreText }}
                  <div class="desc">总得分</div>
                </div>
              </template>
            </van-circle>
          </van-col>
          <van-col span="15">
            <div id="container"></div>
            <van-row class="txt_centre">
              <van-col
                :span="layout"
                v-for="(item, index) in whole.difficulties"
                :key="index"
              >
                <div class="text_box">
                  <div class="num" :class="{ num2: layout == 12 }">
                    {{ item.evaluate }}
                  </div>
                  {{ item.name }}题
                </div>
              </van-col>
            </van-row>
          </van-col>
        </van-row>
        <van-row class="text" type="flex" justify="space-between">
          <van-col span="8">
            <p>
              <span>{{ whole.questionCorrectCount }}题</span>
              答对
            </p>
            <p>
              <span>{{ whole.questionErrorCount }}题</span>
              答错
            </p>
            <p>
              <span>{{ whole.questionInvalidCount }}题</span>
              无效
            </p>
            <van-divider>共测评 {{ tags.count }} 个知识点</van-divider>
            <p>
              <span>{{ tags.excellentCount }}个</span>
              已熟练掌握
            </p>
            <p>
              <span>{{ tags.averageCount }}个</span>
              基本熟练掌握
            </p>
            <p>
              <span>{{ tags.badCount }}个</span>
              未掌握
            </p>
          </van-col>
          <van-col span="14">
            <div class="cell_tit m_bottom" style="color:#303133">
              您所在等级
              <span>（根据知识点熟练掌握情况评定）</span>
            </div>
            <div class="progress m_bottom">
              <div class="sanyan" :style="{ left: whole.rankRate - 5 + '%' }">
                <img :src="stripHeadImg" />
              </div>
              <div class="strip">
                <img :src="stripImg" />
              </div>
              <!-- <div class="nodebox">
                <div
                  class="node"
                  v-for="(item, index) in whole.rankRange"
                  :key="index"
                  :style="{ left: item.rate+4 + '%' }"
                >{{ item.key }}</div>
              </div>-->
            </div>
            <div class="bgbox">
              <div class="cell_tit m_bottom10">学习建议</div>
              {{ whole.propose }}
            </div>
          </van-col>
        </van-row>
      </div>
      <div class="cell_title">知识点熟练掌握情况</div>
      <van-divider />
      <div class="m_bottom40">
        <Table
          :columns="tags.columns"
          :data="tags.data"
          class="m_bottom"
          border
        >
          <template slot-scope="{ row }" slot="attainment">
            <van-rate
              v-model="row.attainment"
              size="11"
              readonly
              gutter="1"
              color="#F2A526"
            />
          </template>
          <template slot-scope="{ row }" slot="score">
            <div class="strip">
              <div
                class="node"
                :class="{
                  brand: row.score >= 85,
                  warning: row.score >= 60 && row.score < 85,
                  danger: row.score < 60
                }"
                :style="{ width: row.scoreRate + '%' }"
              ></div>
            </div>
          </template>
        </Table>
        <div class="bgbox">
          <div class="cell_tit m_bottom10">可提升空间</div>
          <div v-if="tags.propose.weak">
            <van-tag mark color="#F2A526">您还需要攻克的知识点</van-tag>
            <p>{{ tags.propose.weak }}</p>
          </div>
          <div v-if="tags.propose.strengthen">
            <van-tag mark color="#F2A526">您还需要强化的知识点</van-tag>
            <p>{{ tags.propose.strengthen }}</p>
          </div>
          <div v-if="tags.propose.excellent">
            <p>{{ tags.propose.excellent }}</p>
          </div>
        </div>
      </div>
      <div class="cell_title">综合能力</div>
      <van-divider />
      <div id="container2"></div>
      <div class="m_bottom" v-for="(item, index) in levels" :key="index">
        <van-divider content-position="left" v-if="item.tags.length > 0">
          {{ item.name }}
        </van-divider>
        <Table
          :columns="item.columns"
          :data="item.tags"
          class="m_bottom40"
          border
        >
          <template slot-scope="{ row }" slot="attainment">
            <van-rate
              v-model="row.attainment"
              size="11"
              readonly
              gutter="1"
              color="#F2A526"
            />
          </template>
          <template slot-scope="{ row }" slot="score">
            <div class="strip">
              <div
                class="node"
                :class="{
                  brand: row.score >= 85,
                  warning: row.score >= 60 && row.score < 85,
                  danger: row.score < 60
                }"
                :style="{ width: row.scoreRate + '%' }"
              ></div>
            </div>
          </template>
        </Table>
      </div>
    </div>
    <div style="page-break-after: always;"></div>
    <div class="nopadding">
      <img src="../../assets/pdf_footer01.jpg" alt />
      <img src="../../assets/pdf_footer02.jpg" alt />
      <img src="../../assets/pdf_footer03.jpg" alt />
    </div>
    <div class="draft" @click="printPage">
      <van-icon name="printer" />
      <div>打印</div>
    </div>
  </div>
</template>
<script>
import G2 from "@antv/g2";
import { analyseApi } from "@/api/index";
export default {
  data() {
    return {
      show: false,
      show1: false,
      contentShow: false,
      loading: true,
      isZixun: false,
      currentRate: 0,
      gradientColor: {
        "0%": "#69c0ff",
        "100%": "#1890ff"
      },
      name: "",
      spendTime: "",
      finishTime: "",
      whole: {
        score: 0,
        scoreText: "分",
        questionCorrectCount: 0,
        questionErrorCount: 0,
        questionInvalidCount: 0,
        difficulties: [],
        rankRange: [],
        rankRate: 0,
        propose: [],
        rank: ""
      },
      tags: {
        columns: [
          {
            title: "名称",
            key: "name"
          },
          {
            title: "熟练度",
            slot: "attainment",
            width: 100
          },
          {
            title: "得分",
            slot: "score",
            width: 100
          },
          {
            title: "成就度",
            key: "evaluate",
            width: 100
          }
        ],
        data: [],
        propose: {
          weak: [],
          strengthen: [],
          excellent: []
        },
        count: 0,
        averageCount: 0,
        badCount: 0,
        excellentCount: 0
      },
      questions: [],
      levels: [],
      invalidQuestions: [],
      tagInvalidQuestions: [],
      planId: 0,
      examLogId: 0,
      userInfo: {
        realName: "",
        userName: ""
      },
      isShare: false
    };
  },
  mounted() {
    this.planId = this.$route.params.sid;
    this.examLogId = this.$route.params.eid;
    this.getAnalyse();
  },
  methods: {
    printPage() {
      window.print();
    },
    wxclose() {
      this.isZixun = true;
    },
    showTagInvalid(data) {
      this.tagInvalidQuestions = data;
      this.show1 = true;
    },
    startAnswer() {
      this.show = false;
      this.created();
    },
    created() {
      this.timer = setInterval(this.startTimer, 1000);
    },
    startTimer() {
      this.seconds += 1;
      if (this.seconds >= 60) {
        this.seconds = 0;
        this.minutes = this.minutes + 1;
      }
      this.timer = `${this.minutes}分${this.seconds}秒`;
    },
    getAnalyse() {
      let params = {
        planID: this.planId,
        examLogId: this.examLogId
      };
      analyseApi.getAnalyse(params).then(res => {
        this.loading = false;
        this.name = res.data.name;
        this.spendTime = res.data.spendTime;
        this.finishTime = res.data.finishTime;

        this.whole.score = res.data.score;
        this.whole.rank = res.data.rank;
        this.userInfo = res.data.userInfo;
        this.whole.scoreText = res.data.score + "分";
        this.whole.questionCorrectCount = res.data.questionCorrectCount;
        this.whole.questionErrorCount = res.data.questionErrorCount;
        this.whole.questionInvalidCount = res.data.questionInvalidCount;

        this.whole.difficulties = res.data.difficulties;
        this.whole.rankRange = res.data.rankRange;
        this.whole.rankRate = res.data.rankRate;
        this.whole.propose = res.data.propose.join("，");
        this.tags.data = res.data.tags.data;
        this.tags.propose.weak = res.data.tags.propose.weak.join("；");
        this.tags.propose.strengthen = res.data.tags.propose.strengthen.join(
          "；"
        );
        this.tags.propose.excellent = res.data.tags.propose.excellent
          ? res.data.tags.propose.excellent[0]
          : "";
        this.tags.count = res.data.tags.count;
        this.tags.averageCount = res.data.tags.averageCount;
        this.tags.badCount = res.data.tags.badCount;
        this.tags.excellentCount = res.data.tags.excellentCount;
        this.questions = res.data.questions;
        this.levels = res.data.levels.map(item => {
          let columns = [
            {
              title: "名称",
              key: "name"
            },
            {
              title: "熟练度",
              slot: "attainment",
              width: 100
            },
            {
              title: "得分",
              slot: "score",
              width: 100
            },
            {
              title: "成就度",
              key: "evaluate",
              width: 100
            }
          ];
          item.columns = columns;
          return item;
        });
        this.invalidQuestions = res.data.invalidQuestions;

        let data = [];
        res.data.difficulties.forEach(item => {
          let obj = {
            gender: item.name,
            value: item.scoreRate
          };
          data.push(obj);
        });
        const chart = new G2.Chart({
          container: "container",
          forceFit: true,
          height: 150,
          padding: 0
        });
        chart.source(data, {
          value: {
            min: 0,
            max: 100
          }
        });
        chart.legend(false);
        chart.axis(false);
        chart
          .interval()
          .position("gender*value")
          .color("gender", ["#7EBB40", "#F2A526", "#D64B5B"])
          .shape("liquid-fill-gauge")
          .style({
            lineWidth: 7,
            opacity: 0.75
          });

        data.forEach(row => {
          chart.guide().text({
            top: true,
            position: {
              gender: row.gender,
              value: 50
            },
            content: `${row.value}%`,
            style: {
              opacity: 0.75,
              fontSize: 20,
              textAlign: "center",
              fill: "#000"
            }
          });
        });
        chart.render();

        let data2 = [];
        res.data.levels.forEach(item => {
          let obj = {
            question: item.name,
            percent: item.score,
            expected: 100
          };
          data2.push(obj);
        });
        const chart2 = new G2.Chart({
          container: "container2",
          height: 350,
          width: 520,
          padding: [20, 0, 0, 130]
        });
        chart2.source(data2, {
          percent: {
            min: 0,
            max: 100
          }
        });
        chart2.coord("polar", {
          radius: 0.85
        });
        chart2.legend(false);
        chart2.axis("percent", {
          label: {
            offset: 0,
            textStyle: {
              textAlign: "center",
              color: "#000"
            }
          },
          tickLine: null,
          line: {
            stroke: "#606266",
            lineDash: [3, 3]
          },
          grid: {
            lineStyle: {
              stroke: "#606266",
              lineDash: [3, 3]
            }
          } // 设置坐标系栅格样式
        });
        chart2
          .intervalStack()
          .position("question*percent")
          .color("question", ["#62b8d7"])
          .size(50);
        chart2.render();
      });
    },
    goUrl(qid, tid) {
      this.$router.push({
        name: "result",
        params: { eid: this.examLogId, qid: qid },
        query: { tid: tid }
      });
    },
    goIndex() {
      this.$router.push({
        name: "home"
      });
    },
    closeShareTs() {
      localStorage.setItem("isShareTs", "OK");
      this.isShareTs = false;
    }
  },
  filters: {
    format: function(value) {
      if (value > 60) {
        let i = parseInt(value / 60);
        let m = value - 60 * i;
        return i + "分" + m + "秒";
      } else {
        return value + "秒";
      }
    },
    stringOut: function(value) {
      return value.substr(0, 10);
    }
  },
  computed: {
    layout() {
      let n = this.whole.difficulties.length;
      return 24 / n;
    },
    stripImg() {
      let img = "";
      if (this.whole.rank == "A+") {
        img = require("../../assets/strip_a+.jpg");
      } else if (this.whole.rank == "A") {
        img = require("../../assets/strip_a.jpg");
      } else if (this.whole.rank == "B+") {
        img = require("../../assets/strip_b+.jpg");
      } else if (this.whole.rank == "B") {
        img = require("../../assets/strip_b.jpg");
      } else {
        img = require("../../assets/strip_c.jpg");
      }
      return img;
    },
    stripHeadImg() {
      let img = "";
      if (this.whole.rank == "A+") {
        img = require("../../assets/strip_head_a+.jpg");
      } else if (this.whole.rank == "A") {
        img = require("../../assets/strip_head_a.jpg");
      } else if (this.whole.rank == "B+") {
        img = require("../../assets/strip_head_b+.jpg");
      } else if (this.whole.rank == "B") {
        img = require("../../assets/strip_head_b.jpg");
      } else {
        img = require("../../assets/strip_head_c.jpg");
      }
      return img;
    }
  }
};
</script>
<style lang="scss" scoped>
body {
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}
.report {
  width: 190mm;
  margin: 0 auto;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  .van-divider {
    border-color: #8c8c8c;
  }
  .nopadding {
    line-height: 0;
    img {
      width: 100%;
    }
    .userinfo {
      position: relative;
      font-size: 14px;
      color: #303133;
      .username {
        position: absolute;
        top: 190px;
        left: 160px;
      }
      .usertime {
        position: absolute;
        top: 190px;
        left: 450px;
      }
      .usertit {
        font-size: 18px;
        width: 100%;
        text-align: center;
        position: absolute;
        top: 130px;
        font-weight: bold;
      }
    }
  }
  .content {
    padding: 20mm 10mm;
    .cell_title {
      font-size: 20px;
      line-height: 1;
      color: #000;
    }
    .cell_tit {
      font-size: 14px;
      color: #fff;
      line-height: 1;
      span {
        font-size: 12px;
        color: #606266;
      }
    }
    .txt_centre {
      text-align: center;
    }
    .m_bottom {
      margin-bottom: 18px;
    }
    .m_bottom10 {
      margin-bottom: 10px;
    }
    .m_bottom40 {
      margin-bottom: 40px;
    }
    .whole {
      .circle {
        /deep/ .van-circle__text {
          font-size: 24px;
        }
        .scoretext {
          font-size: 40px;
          color: #303133;
          margin-top: 80px;
          .desc {
            color: #606266;
            font-size: 12px;
            line-height: 1.3;
          }
        }
      }
      .text_box {
        position: relative;
        font-size: 14px;
        .num {
          position: absolute;
          left: 0;
          top: -24px;
          width: 100%;
          font-size: 12px;
          color: #606266;
        }
        .num2 {
          top: -17px;
        }
      }
      .text {
        color: #606266;
        font-size: 14px;
        span {
          float: right;
        }
      }
      .progress {
        position: relative;
        padding: 35px 10px 0;
        .sanyan {
          position: absolute;
          top: 2px;
          width: 10%;
          img {
            width: 100%;
          }
        }
        .strip {
          padding-top: 10px;
          position: relative;
          width: 100%;
          height: auto;
          background: none;
          img {
            width: 100%;
          }
        }
        .nodebox {
          margin-top: 8px;
          position: relative;
          height: 20px;
          font-size: 13px;
          .node {
            position: absolute;
          }
        }
      }
    }
    .strip {
      width: 100%;
      height: 6px;
      background-color: #c0c4cc;
      border-radius: 6px;
      margin-top: 7px;
      position: relative;
      .node {
        position: absolute;
        height: 6px;
        border-radius: 6px;
      }
      .node.warning {
        background-color: #62b8d7;
      }
      .node.danger {
        background-color: #d64b5b;
      }
      .node.brand {
        background-color: #7ebb40;
      }
    }
    .bgbox {
      background-color: #62b8d7;
      padding: 20px;
      border-radius: 10px;
      color: #f8f8f8;
      font-size: 12px;
      line-height: 2;
      min-height: 95px;
    }

    /deep/ .ivu-table th {
      background-color: #62b8d7;
      color: #fff;
    }
    /deep/ .ivu-table-border:after {
      background-color: #19a7c4;
    }
    /deep/ .ivu-table:before {
      background-color: #19a7c4;
    }
    /deep/ .ivu-table-wrapper-with-border {
      border: 1px solid #19a7c4;
      border-bottom: 0;
      border-right: 0;
    }
    /deep/ .ivu-table-border td,
    .ivu-table-border th {
      border-right: 1px solid #19a7c4;
    }
    /deep/ .ivu-table td,
    .ivu-table th {
      border-bottom: 1px solid #19a7c4;
    }
    .ivu-table-border td,
    /deep/ .ivu-table-border th {
      border-right: 1px solid #19a7c4;
    }
  }
  .draft {
    width: 50px;
    height: 50px;
    position: fixed;
    right: 10px;
    bottom: 23px;
    background-color: #1cc5f0;
    border-radius: 50px;
    text-align: center;
    color: #fff;
    font-size: 12px;
    line-height: 1;
    border: 1px solid #fff;
    .van-icon {
      font-size: 25px;
      margin-top: 5px;
    }
  }
}
@media print {
  .draft {
    display: none;
  }
}
</style>
